import React, { Component } from "react";
import { connect } from "react-redux";
import ContentHeader from "./ContentHeader";
import { isEmpty } from "lodash";
import { list, create, update } from "../actions";

import { SLBTxtBox, SLBFile } from "../utils/Forms";

import styled from "styled-components";

class AssetForm extends Component {
  state = {
    errors: {},
    asset: {}
  };

  handleChange = event => {
    const { name, value } = event.target;
    let newAsset = { ...this.state.asset, [name]: value };
    this.setState({ ...this.state, asset: newAsset });
  };

  handleSubmit = event => {
    event.preventDefault();
    if (this.isAssetValid(this.state.asset)) {
      this.props.saveAsset(this.state.asset);
    }
  };

  isAssetValid(asset) {
    let errors = {};
    if (isEmpty(asset.title)) {
      errors.title = "Title cannot be empty";
    }

    if (isEmpty(asset.item)) {
      errors.item = "item cannot be empty";
    }
    this.setState({ errors });
    return isEmpty(errors);
  }

  onImageChange = encoded_image => {
    let updatedAsset = { ...this.state.asset, item: encoded_image };
    this.setState({ ...this.state, asset: updatedAsset });
  };

  render() {
    const { title, item } = this.state.asset;
    const { errors } = this.state;
    return (
      <div>
        <h4 className="col-md-12">New asset </h4>
        <form onSubmit={this.handleSubmit}>
          <div className="clearfix">
            <SLBTxtBox
              label="Title"
              name="title"
              value={title}
              context={this}
              attrs={{ errors, klass: "col-md-12" }}
            />
            <SLBFile
              label="Image"
              name="image_file"
              onImageChange={this.onImageChange}
              attrs={{}}
            />
            <div className="col-md-12">
              {item &&
                <img alt={title} style={{ maxWidth: "600px" }} src={item} />}
            </div>
            <br />
            <div className="col-md-12 edit-buttons-pane">
              <input
                className="btn btn-success pull-right"
                type="submit"
                value="Submit"
              />
              <a
                className="btn btn-default pull-right"
                style={{ marginRight: 10 }}
                onClick={this.props.hideForm}
              >
                Cancel
              </a>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const AssetContainer = styled.div`
  max-width: 200px;
  padding: 16px;
`;

const AssetImage = styled.img`
  width: 100%
`;

const AssetTitle = styled.div`
    text-align: center;
    padding: 8px;
    color: #82232A;
`;

const Asset = ({ item, title }) => {
  return (
    <AssetContainer>
      <AssetImage src={item.url} />
      <AssetTitle>{title}</AssetTitle>
    </AssetContainer>
  );
};

const AssetListContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap
`;

class AssetList extends Component {
  render() {
    const { assets } = this.props;
    return (
      <div>
        <h4>List</h4>
        <AssetListContainer>
          {assets && assets.map((asset, idx) => <Asset key={idx} {...asset} />)}
        </AssetListContainer>
      </div>
    );
  }
}

class AssetsManager extends Component {
  componentDidMount() {
    this.props.fetchAssets();
  }

  render() {
    const { assets, formVisible } = this.props;
    return (
      <div>
        <ContentHeader title="Assets">
          <span className="pull-right">
            {formVisible === false &&
              <button className="btn btn-primary" onClick={this.props.showForm}>
                Add Asset
              </button>}
          </span>
        </ContentHeader>

        {formVisible &&
          <AssetForm
            hideForm={this.props.hideForm}
            saveAsset={this.props.saveAsset}
          />}
        <AssetList assets={assets} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { list, formVisible } = state.assets;
  return {
    assets: list,
    formVisible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideForm() {
      dispatch({ type: "HIDE_ASSET_FORM" });
    },
    showForm() {
      dispatch({ type: "SHOW_ASSET_FORM" });
    },
    fetchAssets() {
      dispatch(list("assets"));
    },
    saveAsset(asset) {
      if (asset.id) {
        dispatch(update("asset", asset));
      } else {
        dispatch(create("asset", asset));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetsManager);



// WEBPACK FOOTER //
// ./src/components/AssetsManager.js